import React from 'react';

import { LinkButton } from 'src/app/components/lib/button';

import {
  SummaryCardBody,
  SummaryCardBodyRow,
  SummaryCardContainer,
  SummaryCardRowTitle,
  SummaryCardRowValue,
  SummaryCardTitle,
} from './styled';

type RowWithElementFieldTitle = {
  fieldTitle: React.ReactElement;
  fieldValue: React.ReactChild;
  keyTitle: string;
};

type RowWithTextFieldTitle = {
  fieldTitle: string;
  fieldValue: React.ReactChild;
  keyTitle?: never;
};

// if the fieldTitle is not a string, require a keyTitle prop (string) for use in the key prop below
type Row = RowWithElementFieldTitle | RowWithTextFieldTitle | undefined;

function rowHasTextTitle(row: Row): row is RowWithTextFieldTitle {
  return typeof row?.fieldTitle === 'string';
}

function getRowTitle(row: Row): string {
  if (rowHasTextTitle(row)) {
    return row.fieldTitle;
  }

  if (row?.keyTitle === undefined) {
    return '';
  }
  return row?.keyTitle;
}

export type SummaryCardProps = {
  onEditClick: () => void;
  rows: Row[];
  title: string;
};

export function SummaryCard({ onEditClick, rows, title }: SummaryCardProps) {
  return (
    <SummaryCardContainer data-testid={`summary-card_${title}`}>
      <SummaryCardTitle>
        <div>{title}</div>
        <LinkButton label='Edit' sx={{ padding: 0, minWidth: 'unset' }} onClick={onEditClick} />
      </SummaryCardTitle>
      <SummaryCardBody>
        {rows.map((row, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SummaryCardBodyRow key={`${title}-${getRowTitle(row)}-${index}`}>
            <SummaryCardRowTitle>{row?.fieldTitle}</SummaryCardRowTitle>
            <SummaryCardRowValue>{row?.fieldValue}</SummaryCardRowValue>
          </SummaryCardBodyRow>
        ))}
      </SummaryCardBody>
    </SummaryCardContainer>
  );
}
